module.exports = __webpack_public_path__ + "static/exercise-img-9-854b60b2f2683c8ff4bcb41e9a9fe85d.png";